import { EditPage, EditPageTextField, EditPagePanel, EditPageSelect } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

const TeamsEdit = (props) => {
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({ companies: [], branches: [] });
    const navigate = useNavigate();
    const { teamId } = useParams();

    useEffect(() => {
        getOne('/admin/clients/teams/', teamId).then(response => {
            setData(response.data.data);
        });
        getOne('/admin/clients/teams/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, [teamId]);

    const handleSave = () => {
        update('/admin/clients/teams/', teamId, { data }).then(response => {
            toast.success('Team updated successfully', {});
            navigate('/clients/teams');
        }).catch(error => {
            toast.error('Error updating team: ' + error.message, {});
        });
    };

    const handleCancel = () => {
        navigate('/clients/teams');
    };

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    };

    return (
        <div>
            <ToastContainer />
            <EditPage handleSave={handleSave} handleCancel={handleCancel} title="Edit Team">
                <EditPagePanel className="col-lg-8">
                    <EditPageTextField label="Name" id="name" onChange={onChange} value={data.name} required={true} />
                    <EditPageSelect
                        label="Company"
                        id="company_id"
                        onChange={onChange}
                        value={data.company_id}
                        options={Object.fromEntries((metadata.companies || []).map(c => [c.id, c.name]))}
                        required={true}
                    />
                    <EditPageSelect
                        label="Branch"
                        id="branch_id"
                        onChange={onChange}
                        value={data.branch_id}
                        options={Object.fromEntries((metadata.branches || []).map(b => [b.id, b.name]))}
                        required={false}
                    />
                </EditPagePanel>
            </EditPage>
        </div>
    );
};

export default TeamsEdit; 